import { initialState } from '@/models/options';

const v26 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...initialState.tableViews.invoicesTable,
          'Compilation Code': true,
        },
      },
    },
  };
};

export default v26;
